// extracted by mini-css-extract-plugin
export var highlightFade = "_2r-4";
export var highlighted = "_2r-3";
export var table = "_2r-1";
export var tableContainer = "_2r-0";
export var totalsRow = "_2r-2";